import { createContext, useReducer, useEffect } from 'react';
import {
  targetConsented,
  targetConsentedOrPrompted,
} from '@tv2/ui-ng/libraries/tracking/adobeTargetHelpers';

export const experimentContext = createContext<any>({ experiments: undefined, loading: false });

export function useFetchTargetMBox(mbox: string) {
  const [state, dispatch] = useReducer(experimentsReducer, {
    loading: true,
    experiments: [],
  });

  useEffect(() => {
    let mounted = true;
    targetConsentedOrPrompted().catch(() => {
      if (mounted) dispatch({ type: 'consent' });
    });
    targetConsented()
      .then(() => {
        (window as any).adobe.target.getOffer({
          mbox,
          params: {},
          success: (offers: string) => dispatch({ type: 'success', payload: offers }),
          error: () => dispatch({ type: 'error' }),
          timeout: 1000,
        });
      })
      .catch(() => dispatch({ type: 'error' }));

    return () => {
      mounted = false;
    };
  }, [mbox]);

  return state;
}

export default function ExperimentProvider({ children, config }: any) {
  const pathname = typeof window !== 'undefined' ? window.location.pathname : 'serverside';
  const targetMBox = useFetchTargetMBox(pathname);

  return <experimentContext.Provider value={targetMBox}>{children}</experimentContext.Provider>;
}

function experimentsReducer(state: any, action: any) {
  switch (action.type) {
    case 'success':
      return {
        loading: false,
        experiments: action.payload
          .filter((x: any) => x.action === 'setJson')
          .map((x: any) => x.content)
          .flat(),
      };
    case 'error':
      return { loading: false, experiments: [] };
    case 'consent': {
      return { loading: false };
    }
    default:
      throw new Error();
  }
}
